import { AxiosError } from 'axios';
import { fetcher, getRequestConfig, UnauthorizedError } from './fetcher';

export type AvailableProductsResponse = {
  availableProducts: string[];
};

const emptyResponse: AvailableProductsResponse = {
  availableProducts: [],
};

const Paths = {
  AVAILABLE_PRODUCTS: '/payroll/available-products',
};

const availableProducts = async (): Promise<AvailableProductsResponse> => {
  try {
    const result = await fetcher.get<AvailableProductsResponse>(
      Paths.AVAILABLE_PRODUCTS,
      getRequestConfig(),
    );

    return result.data;
  } catch (error) {
    if ((error as AxiosError)?.response?.status === 404) {
      return emptyResponse;
    }

    if ((error as AxiosError)?.response?.status === 401) {
      throw new UnauthorizedError((error as AxiosError)?.message);
    }

    throw new Error(`Could not check products - ${error}`);
  }
};

export { availableProducts };
